/**
 * 公告中心
 */

export const NoticeList = [
    {
        prop: "title",
        label: "公告标题",
        width: "150",
        format: "",
        order: false,
        isShow: true
    },
    {
        prop: "startDate",
        label: "开始时间",
        width: "150",
        format: "datetime",
        order: false,
        isShow: true
    },
    {
        prop: "endDate",
        label: "结束时间",
        width: "150",
        format: "datetime",
        order: false,
        isShow: true
    },
    {
        prop: "creatorName",
        label: "创建人",
        width: "150",
        format: "",
        order: false,
        isShow: true
    },
    {
        prop: "creationTime",
        label: "创建时间",
        width: "150",
        format: "datetime",
        order: false,
        isShow: true
    }
]